// extracted by mini-css-extract-plugin
export var buttons = "_au-0";
export var buttonsActive = "_au-h";
export var cancelConfirm = "_au-1";
export var closeButton = "_au-2";
export var column = "_au-3";
export var container = "_au-4";
export var detailHeader = "_au-6";
export var detailTitle = "_au-7";
export var detailsContent = "_au-5";
export var header = "_au-8";
export var headerWithClose = "_au-9";
export var icon = "_au-a";
export var infoIcon = "_au-c";
export var informationContainer = "_au-b";
export var sideDrawer = "_au-d";
export var sideDrawerOpen = "_au-e";
export var stickyFooter = "_au-f";
export var typeOption = "_au-g";